import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
`;

const Select = styled.select`
	-webkit-appearance: none;
	font-size: 1em;
	font-family: GothamLight!important;
	padding-left: 1em;
	display: block;
	padding-left: 10px;
	width: calc(100%);
	font-size: 14px;
	line-height: 1.42857143;
	color: #555;
	background-color: #fff;
	background-image: none;
	border: 1px solid #575757;
	border-radius: .5em;
	height: 47px;
	box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
	transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
	background: url(/images/shevron-grey.png) no-repeat 99% 50%;
	background-size: 25px;
	&:focus {
		outline: none;
	}
	&::-ms-expand {
		display: none;
	}
`;

class DropdownInput extends Component {

	state = { isOpen: false };

	input = null;

	componentWillMount() {
		if (this.props.value === '') {
			setTimeout(() => this.props.onChange(this.props.options[0]), 500);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.value !== prevProps.value) {
			this.input.value = this.props.value;
		}
	}

	onChange = e => this.props.onChange(e.target.value);

	render() {
		const { options, id, name, value, style } = this.props;
		if (!options) return null;
		return (
			<Wrapper>
				<Select {...{ id, name, value, style, onChange: this.onChange, ref: input => this.input = input }} >
					{options.map((value) => (<option key={value} value={value} >{value}</option>))}
				</Select>
			</Wrapper>
		);
	}
}

export default DropdownInput;



// WEBPACK FOOTER //
// ./src/html/controls/DropdownInput.js